export default class Component {
    constructor(name, text, abrev, enable, textPlural, tipo) {

        this.name = name;
        this.text = text;
        this.abrev = abrev;
        this.enable = enable;
        this.textPlural = textPlural;
        this.tipo = tipo;

    }
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/component/Component.js